import * as React from 'react';
import Modal from '@mui/joy/Modal';
import ModalClose from '@mui/joy/ModalClose';
import Typography from '@mui/joy/Typography';
import Sheet from '@mui/joy/Sheet';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { format } from "date-fns";
import CircularProgress from '@mui/joy/CircularProgress';
import user1 from "../../images/ic_no_person_photo.svg";
import { base_url } from '../../utils/AxiosConfig';
import { base_url_image_view_api } from '../../utils/ImageViewingAPI';




export default function BasicModal(props) {

    const [isCallingAPI, setIsCallingAPI] = useState(false)

    const startOfMonth = new Date();
    startOfMonth.setUTCDate(1);

    const { popUpData, setpopUpData, openViewModal, setOpenViewModal } = props

    const [timeSheetArray, setTimeSheetArray] = useState(null)

    let initialStartingDate = format(startOfMonth, 'yyyy-MM-dd')
    let initialEndingDate = format(new Date(), 'yyyy-MM-dd')

    console.log("initial popUpData", initialStartingDate, initialEndingDate, popUpData, startOfMonth)

    const [timeSheetData, setTimeSheetData] = useState({
        startDate: initialStartingDate,
        endDate: initialEndingDate
    })

    const handleChange = (e) => {
        const { name, value } = e.target;
        setTimeSheetData({
            ...timeSheetData,
            [name]: value,
        });
    };

    const getTimeSheet = () => {

        setIsCallingAPI(true)
        console.log("get timesheet ",)

        let apiUrl = `${base_url}api/TimesheetList/CUBIX/${popUpData?.EmpId}/${timeSheetData.startDate}/${timeSheetData.endDate}`

        let apiWPSUrl = `${base_url}api/WPSGen/CUBIX/-/-/${timeSheetData.startDate}/${timeSheetData.endDate}`

        console.log("apiUrl timesheet ", apiUrl)

        axios.get(apiWPSUrl).then((res) => {

            setIsCallingAPI(false)
            console.log("res -->", res.data)

            setTimeSheetArray(res.data)

        }).catch((err) => {

            setIsCallingAPI(false)
        })
    }

    const fetchProfilePic = (ImagePath) => {
        const filePath = ImagePath.replace(/\\/g, "/");
        const fileName = filePath.split('/').pop(); // Extracts the last part (filename with extension)

        // Construct the full URL for the image
        return `${base_url_image_view_api}/BONDTIME_EMP_IMG/${fileName}`;
    };


    useEffect(() => {

        getTimeSheet()

    }, [])


    return (


        <Modal
            open={openViewModal}
            onClose={() => { setOpenViewModal(false); setpopUpData(null) }}
            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        >
            <Sheet
                variant="outlined"
                sx={{ maxWidth: 500, minWidth: "80%", borderRadius: 'md', p: 3, boxShadow: 'lg' }}
            >
                <ModalClose variant="plain" sx={{ m: 1 }} />
                <Typography
                    component="h2"
                    id="modal-title"
                    level="h4"
                    textColor="inherit"
                    sx={{ fontWeight: 'lg', mb: 1 }}
                >
                    View WPS
                </Typography>

                <div>
                    <div className="container-fluid mt-4">

                        <div className='d-flex justify-content-between'>

                            <div style={{ width: "50%" }}>
                                {/* <table class="table border" style={{ height: "100%" }}>
                                    <thead>
                                        <tr>
                                            <th>EmpID</th>
                                            <th>Name</th>
                                            <th>Designation</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr>
                                            <td>{popUpData?.EmpId}</td>
                                            <td>
                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                    {popUpData.imagepath ?
                                                        <img style={{
                                                            width: "25px",
                                                            height: "25px",
                                                            borderRadius: "50%",
                                                            objectFit: "cover",
                                                            marginRight: "4px"
                                                        }} src={fetchProfilePic(popUpData.imagepath)} alt="" /> :
                                                        <img style={{
                                                            width: "25px",
                                                            height: "25px",
                                                            borderRadius: "50%",
                                                            objectFit: "cover",
                                                            marginRight: "4px"
                                                        }} src={user1} alt="" />
                                                    }
                                                    <span>{popUpData?.Name}</span>
                                                </div>

                                            </td>
                                            <td>{popUpData?.JobTitle}</td>
                                        </tr>


                                    </tbody>
                                </table> */}

                                <div style={{ display: "flex" }}>
                                    <div>
                                        {popUpData.imagepath ?
                                            <img style={{
                                                width: "85px",
                                                height: "85px",
                                                borderRadius: "50%",
                                                objectFit: "cover",
                                                marginRight: "4px"
                                            }} src={fetchProfilePic(popUpData.imagepath)} alt="" /> :
                                            <img style={{
                                                width: "85px",
                                                height: "85px",
                                                borderRadius: "50%",
                                                objectFit: "cover",
                                                marginRight: "4px"
                                            }} src={user1} alt="" />
                                        }
                                    </div>
                                    <div>
                                        <div>
                                            {popUpData?.Name}
                                        </div>
                                        <div>
                                            {popUpData?.EmpId}
                                        </div>
                                        <div style={{ color: "rgb(160, 160, 160)" }}>
                                            {popUpData?.JobTitle}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div style={{ width: "50%", backgroundColor: "#f7f7f7" }}>
                                {/* date start */}
                                <div className='date-holder d-flex justify-content-around align-items-end p-2'>

                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <div >
                                            <label for="exampleInputEmail1" class="form-label fs-small text-secondary">Start Date</label>
                                            <input type="date"
                                                class="form-control"
                                                id="startDate"
                                                name="startDate"
                                                value={timeSheetData.startDate}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className='ms-2'>
                                            <label for="exampleInputEmail1" class="form-label fs-small text-secondary">End Date</label>
                                            <input
                                                type="date"
                                                class="form-control"
                                                id="endDate"
                                                name="endDate"
                                                value={timeSheetData.endDate}
                                                onChange={handleChange}
                                            />

                                        </div>
                                    </div>

                                    <div>
                                        <button onClick={() => getTimeSheet()} className='btn dash-btn'>View</button>
                                    </div>

                                </div>

                            </div>

                            {/* date end */}
                        </div>



                        {
                            isCallingAPI ?

                                <div className='d-flex justify-content-center w-100 p-4'>
                                    <CircularProgress size="lg" />
                                </div>

                                :

                                <div className='scroll' style={{ maxHeight: "300px", marginTop: "20px" }}>
                                    <table class="table">

                                        <thead>
                                            <tr className="">
                                                <th>Sl.No. </th>
                                                <th>Tot Wage </th>
                                                <th>Date</th>
                                                <th>Entry Date</th>

                                                <th>Nr Hrs</th>
                                                <th>Nr Rate</th>

                                                <th>Ot Hrs</th>
                                                <th>Ot Rate</th>

                                                <th>Ots Hrs</th>
                                                <th>Ots Rate</th>

                                                <th>Remarks</th>
                                                <th>Type</th>
                                            </tr>
                                        </thead>

                                        <tbody>



                                            {
                                                timeSheetArray?.map((item) => {
                                                    return (

                                                        <tr className="dataTr">
                                                            <td>{item.slno}</td>
                                                            <td>{item.tot_wage}</td>
                                                            <td>{item.Date} </td>
                                                            <td>{item.entry_date}</td>

                                                            <td>{item.nr_hrs}</td>
                                                            <td>{item.nr_rate}</td>

                                                            <td>{item.ot_hrs}</td>
                                                            <td>{item.ot_rate}</td>

                                                            <td>{item.ots_hrs}</td>
                                                            <td>{item.ots_rate}</td>

                                                            <td>{item.remarks}</td>
                                                            <td>{item.type}</td>
                                                        </tr>
                                                    )
                                                })
                                            }


                                        </tbody>

                                    </table>
                                </div>
                        }

                    </div>
                </div>

            </Sheet>
        </Modal>

    );
}